import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from '../constants/redux/cottages';

const initialState = {
  isFetching: false,
  data: [],
  error: null,
  stats: {},
  tags: [],
};

const setFetchCottagesRequest = (state) => update(state, {
  isFetching: { $set: true },
});

const setFetchCottagesSuccess = (state, action) => update(state, {
  isFetching: { $set: false },
  data: { $set: action.payload.data },
  error: { $set: null },
});

const setFetchCottagesFailure = (state, action) => update(state, {
  isFetching: { $set: false },
  data: { $set: [] },
  error: { $set: action.payload.error },
});

const setFetchStatsRequest = (state, action) => update(state, {
  stats: { [action.payload.id]: { $set: { isLoading: true } } },
});

const setFetchStatsSuccess = (state, action) => update(state, {
  stats: {
    [action.payload.id]: {
      $set: {
        isLoading: false,
        total: action.payload.total,
        rows: action.payload.rows,
      },
    },
  },
});

const setFetchStatsFailure = (state, action) => update(state, {
  stats: { [action.payload.id]: { $set: { isLoading: false } } },
  error: { $set: action.payload.error },
});

const updateCottagesData = (state, action) => update(state, {
  data: {
    $splice: [
      [state.data.map(({ id }) => id).indexOf(action.payload.data.id), 1, action.payload.data],
    ],
  },
});

const setCottagesTags = (state, { payload }) => update(state, {
  tags: { $set: payload },
});

export default handleActions({
  [constants.FETCH_COTTAGES_REQUEST]: setFetchCottagesRequest,
  [constants.FETCH_COTTAGES_SUCCESS]: setFetchCottagesSuccess,
  [constants.FETCH_COTTAGES_FAILURE]: setFetchCottagesFailure,

  [constants.FETCH_STATS_REQUEST]: setFetchStatsRequest,
  [constants.FETCH_STATS_SUCCESS]: setFetchStatsSuccess,
  [constants.FETCH_STATS_FAILURE]: setFetchStatsFailure,

  [constants.UPDATE_COTTAGES_DATA]: updateCottagesData,

  [constants.FETCH_COTTAGES_TAGS_SUCCESS]: setCottagesTags,
}, initialState);
